/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Sai Lohith",
  logo_name: "SaiLohith",
  subTitle:
    "Software Engineer | 3+ YOE | Full Stack & AI Integration\n\nI am a Software Engineer with a Master's in Computer Science and over 3 years of experience building scalable platforms for FinTech, Research, and Mobility sectors. I specialize in bridging the gap between robust backend systems and modern AI architectures.",
 
  portfolio_repository: "https://github.com/Motupallisailohith",
};

const socialMediaLinks = [
 

  {
    name: "Github",
    link: "https://github.com/Motupallisailohith",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sailohithm/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:sailohith1439@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#EA4335", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://x.com/SaiLohi51044179",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },

  {
    name: "Instagram",
    link: "https://www.instagram.com/lohithm.me/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        
        "⚡ Building robust and scalable backend systems using Java (Spring Boot) and Python (Flask).",
        "⚡ Designing and developing responsive web frontends using React, HTML, and CSS.",
        "⚡ Implementing RESTful APIs and microservices architecture to ensure modularity and scalability.",
        "⚡ Enhancing system performance and reliability with advanced caching mechanisms and message queues.",
        "⚡ Collaborating across the stack to deliver seamless, full-stack solutions.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java",
          style: {
            color: "#e6e6e6",
          },
        },
        {
          skillName: "Spring Framework",
          fontAwesomeClassname: "devicon:spring",
          style: {
            color: "#77bc1f",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "devicon:jenkins",
          style: {
            color: "#1d1919",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "devicon:redis",
          style: {
            color: "#7a0c00",
          },
        },
        {
          skillName: "Apache Kafka",
          fontAwesomeClassname: "skill-icons:kafka",
          style: {
            color: "#000",
          },
        },
        {
          skillName: "Git-vcs",
          fontAwesomeClassname: "mdi:git",
          style: {
            backgroundColor: "transparent",
          },
        },
        
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
       
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "AI & LLM Integration",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Transitioned from rule-based automation to AI agents using LangChain, LangGraph, and LLMs",
        "⚡ Integrating with VectorDBs (Qdrant) and GraphDBs (Neo4j) for advanced data management",
        "⚡ Building intelligent systems that leverage large language models for complex automation tasks",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:chainlink",
          style: {
            backgroundColor: "transparent",
            color: "#375BD2",
          },
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            backgroundColor: "transparent",
            color: "#412991",
          },
        },
        {
          skillName: "LangGraph",
          fontAwesomeClassname: "mdi:graph-outline",
          style: {
            backgroundColor: "transparent",
            color: "#00D4AA",
          },
        },
        {
          skillName: "Qdrant",
          fontAwesomeClassname: "mdi:database-search",
          style: {
            backgroundColor: "transparent",
            color: "#DC244C",
          },
        },
        {
          skillName: "Neo4j",
          fontAwesomeClassname: "simple-icons:neo4j",
          style: {
            backgroundColor: "transparent",
            color: "#008CC1",
          },
        },
        {
          skillName: "Claude AI",
          fontAwesomeClassname: "mdi:robot-outline",
          style: {
            backgroundColor: "transparent",
            color: "#D97757",
          },
        },
        {
          skillName: "MCP",
          fontAwesomeClassname: "mdi:api",
          style: {
            backgroundColor: "transparent",
            color: "#6366F1",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/sailohith1439",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://leetcode.com/u/sailohith1439",
    },
    {
      siteName: "Qwiklabs-GCP",
      iconifyClassname: "cib:qwiklabs",
      style: {
        color: "#F5CD0E",
      },
      profileLink:
        "https://www.cloudskillsboost.google/public_profiles/361a6ee2-6e72-4fba-876e-6657b2bd1247",
    },
  ],
};

const degrees = {
  degrees: [
    
    {
      title: "Georgia State University",
      subtitle: "Master of Science in Computer Science (MSCS)",
      logo_path: "gsu_round.png",
      alt_name: "GSU",
      duration: "August 2024 - current",
      descriptions: [
        "🌟Specialized in cutting-edge technologies through advanced coursework in Text Processing, Image Processing, and Human-Computer Interaction.",
        "🌟Gained hands-on experience in Mobile App Development, Web Development, and Advanced Computer Networks, building scalable and interactive applications.",
        "🌟Developed strong foundations in Machine Learning, with practical exposure to real-world datasets and model deployment.",
      ],
      website_link: "https://www.gsu.edu/",
    },
    {
      title: "Lovely Professional University",
      subtitle: "Bachelor's in Computer Science & Engineering (B.TECH)(Hons)",
      logo_path: "Lovely_Professional_University_logo.png",
      alt_name: "LPU",
      duration: "2017 - 2021",
      descriptions: [
        "🌟 Data Science, with a strong foundation in Data Structures & Algorithms, Database Systems, and Full Stack Development.",
        "🌟 Completed core courses including Operating Systems, Computer Networks, Computer Organization & Design, and electives like Animation, Game Development, and Cloud Computing.",
        "🌟 ursued an Honours degree with exposure to interdisciplinary subjects such as Engineering Drawing, Engineering Physics, and Engineering Mathematics, alongside active involvement in the Google Developer Student Club to enhance hands-on learning and collaboration.",
      ],
      website_link: "https://www.lpu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Google Digital Garage",
      subtitle: "-56L CEH JQY",
      logo_path: "gdg.png",
      certificate_link:
        "https://learndigital.withgoogle.com/digitalgarage/validate-certificate-code",
      alt_name: "Google Digital Garage",
      color_code: "#1a73e8",
    },
    {
      title: "Data Structures And Algorithms",
      subtitle: "-Sandeep Jain",
      logo_path: "images.png",
      certificate_link:
        "https://drive.google.com/file/d/1O0W_9q9sDbpqDTvL4rQnP9cqkP_Z1XNT/view?usp=sharing",
      alt_name: "GeeksForGeeks",
      color_code: "#28a745",
    },
    {
      title: "Learning Paladin",
      subtitle: "-Digital base 1",
      logo_path: "676-6762434_cognizant-logo-png.png",
      certificate_link:
        "https://drive.google.com/file/d/1Po-6nsxeDnMeyUVVldKXgm0mOKTmWEkj/view",
      alt_name: "Learning Paladin",
      color_code: "#0C9D5899",
    },
    {
      title: "Sparkling Star",
      subtitle: "-Digital base 1",
      logo_path: "676-6762434_cognizant-logo-png.png",
      certificate_link:
        "https://drive.google.com/file/d/1YHs4m3oXz7fmHxgo-DhGm9_CNEaKgCLg/view",
      alt_name: "Sparkling-star",
      color_code: "#1F70C199",
    },
    {
      title: "Cloud Master Class",
      subtitle: "-Goutham Nanjudaswamy",
      logo_path: "aws.png",
      certificate_link:
        "https://drive.google.com/file/d/1Twqwqcp8th0FgRxY0bvLmm0wMQCuHy6Q/view",
      alt_name: "AWS",
      color_code: "#fff",
    },
    {
      title: "Software Engineering",
      subtitle: "- -A.Goswami",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1zuWIPsrpCQjZRIbdLlRCQFKB1YfdcCY6/view",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Data Science For Engineers",
      subtitle: "-Andrew Thangaraj",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1o2RBnQLx8skd5b-bZDyDbbnMyOihIvsi/view",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Google Career Certification",
      subtitle: "-Prepare Data for Exploration",
      logo_path: "coursera-logo-full-rgb.png",
      certificate_link:
      "https://www.coursera.org/account/accomplishments/certificate/4LC2ACAGBREF",
      alt_name: "Coursera",
      color_code: "#fff",
    },
    {
      title: "Google Career Certification",
      subtitle: "-Introduction to Cloud Identity",
      logo_path: "coursera-logo-full-rgb.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/2JZKB2SXZR2N",
      alt_name: "Coursera",
      color_code: "#fff",
    },
],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked in Bosch's Centre of Excellence department which is a reputed entity for many Bosch's subsidaries and startups, I got the opportunity to innovate harmonized automoation framework using Java, Spring, Python, Django and DevOps frameworks which created a massive impact in the world of mobility solutions by reducing the requirement of human resources and long timelines",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineering Intern",
          company: "FloData",
          company_url: "https://flodata.io/",
          logo_path: "fd.png",
          duration: "May 2025 - August 2025",
          location: "Milpitas, Califronia",
          description: [
        "🌟Defining Data Migration/Ingestion/Validation worklows with Agentic AI systems built on MCP, these autonomously execute and configure worklows"
      ],
          color: "#0879bf",
        },
        {
          title: "Graduate Research Assistant",
          company: "Georgia State University",
          company_url: "https://www.gsu.edu/",
          logo_path: "gsu.png",
          duration: "August 2024 - Current",
          location: "Atlanta, Georgia",
          description: [
        "🌟Developed deep-learning models for Health Informatics using Tensorflow and Python.",
        "🌟Contributed to research work by enabling data workflow pipelines with Pandas.",
      ],
          color: "#9b1578",
        },
        {
          title: "Software Engineer",
          company: "Bosch Global Software Technologies",
          company_url: "https://www.bosch-softwaretechnologies.com/en/",
          logo_path: "bosch-logo.png",
          duration: "Jan 2022 - December 2023",
          location: "Bangalore, Karnataka",
          description:
            "Built a global automation platform for OEMs, scaled report generation capacity 3.5×, improved system latency with async execution, streamlined CI/CD pipelines, and reduced engineering overhead through end-to-end workflow optimization",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Engineering Intern",
          company: "DevRabbit",
          company_url:
            "https://www.devrabbit.com/",
          logo_path: "devrabbit.png",
          duration: "January 2021 - May 2021",
          location: "Hyderabad, Telangana",
          description:
            "Engineered fintech transaction systems, optimized real-time dashboard performance, improved alert delivery reliability, decoupled backend alert workflows, and streamlined customer interaction pipelines.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Student Developer",
          company: "DevRabbit",
          company_url:
            "https://dscgt.club/",
          logo_path: "gdsc.png",
          duration: "Nov 2018` - May 2022",
          location: "Jalandhar, Punjab",
          description:
            "- Conducting Tech Events & Instructing Tech stacks to fellow student chapter members, Participating in hackathons & developer fests to network with Industry experts",
          color: "#ee3c26",
        },
        {
          title: "IT Consultant",
          company: "SPADE",
          company_url:
            "https://spadeems.com/",
          logo_path: "spade.png",
          duration: "Jan 2020` - May 2020",
          location: "Jalandhar, Punjab",
          description:
            "Developed Website to market Spade EMS as a one stop organization to conduct events, handling PR, Sponsorships and Treasury",
          color: "#ee3c26",
        },
      ],
      
    },
    
    
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Welcome to my Projects page—a showcase of work that reflects a multidisciplinary skill set spanning Full Stack Development, DevOps, Data Engineering, Artificial Intelligence & Machine Learning, and Cybersecurity. Each project demonstrates a hands-on approach to building scalable systems, automating infrastructure, securing applications, and applying data-driven intelligence to solve real-world problems. Whether it's end-to-end application development, cloud-native deployment, data pipelines, or AI/ML models, you'll find a blend of innovation and technical depth across domains.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Backend Software Development using Java, Python, Spring, React and DevOps frameworks.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I used to write a blog for students who are searching for best engineering disciplines and colleges",
    link: "https://clgvouge.blogspot.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "2450 Camellia Ln, NE, Atlanta, USA - 30324",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/7LAeuT2YF1SvHKJR7",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 (913) 413 6530",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
